// Redirect recovery_token or invite_token hash to /admin path
// This runs immediately when Gatsby loads, before any React code
exports.onClientEntry = () => {
  if (typeof window !== 'undefined') {
    const hash = window.location.hash || '';
    if (hash) {
      const lowerHash = hash.toLowerCase();
      if (lowerHash.includes('recovery_token=') || lowerHash.includes('invite_token=')) {
        const currentPath = window.location.pathname || '/';
        // Only redirect if not already on /admin path
        if (!currentPath.startsWith('/admin')) {
          window.location.replace(`/admin${hash}`);
        }
      }
    }
  }
};

